
<div class="flex justify-center">
  <Card class="generic-error-card" :customClasses="customCardClasses">
    <OopsIllustration class="mx-auto" />
    <h2 class="text-h3 text-center mt-16">{{ title }}</h2>
    <p class="body-1 text-center mt-8">
      <slot>
        There was an error loading this page. Refresh the page to try again or
        <a class="link-secondary underline" href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank"
          >contact us</a
        >
        if the issue continues.
      </slot>
    </p>
    <Button :value="buttonValue" variant="primary" size="medium" class="w-full mt-16" :href="buttonHref" @click="handleClick" />
  </Card>
</div>
